export const NOT_ADMIN_ADDRESS = "0x0000000000000000000000000000000000000000";